// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"generalizedModal_backdrop__9K0CN"};